import * as React from 'react';
import { SVGProps } from 'react';

const Close = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0.953125 11.4141C1.28906 11.75 1.85938 11.7422 2.1875 11.4141L6 7.60938L9.80469 11.4141C10.1328 11.7422 10.7031 11.75 11.0391 11.4141C11.375 11.0781 11.3672 10.5078 11.0391 10.1797L7.23438 6.36719L11.0391 2.5625C11.3672 2.23438 11.375 1.66406 11.0391 1.32812C10.7031 0.992188 10.1328 1 9.80469 1.32812L6 5.13281L2.1875 1.32031C1.85938 1 1.28906 0.992188 0.953125 1.32812C0.617188 1.66406 0.625 2.23438 0.953125 2.5625L4.75781 6.36719L0.953125 10.1797C0.625 10.5078 0.617188 11.0781 0.953125 11.4141Z"
            fill="#3C3C43"
            fillOpacity="0.6"
        />
    </svg>
);

export default Close;
